import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.data.FranchiseeQuoteManager.';
  public static readonly currentUserDoesNotHaveBranch = `${Id.prefix}currentUserDoesNotHaveBranch`;
  public static readonly unableToCreatePurchaseOrder = `${Id.prefix}unableToCreatePurchaseOrder`;
  public static readonly issueOrderBySupplierFailed = `${Id.prefix}issueOrderBySupplierFailed`;
  public static readonly issueOrderBySupplierFailedRecovered = `${Id.prefix}issueOrderBySupplierFailedRecovered`;
  public static readonly errorProcessingPurchaseOrder = `${Id.prefix}errorProcessingPurchaseOrder`;
  public static readonly purchaseOrderCreated = `${Id.prefix}purchaseOrderCreated`;
  public static readonly projectCreated = `${Id.prefix}projectCreated`;
  public static readonly quoteLinkedToExistingProject = `${Id.prefix}quoteLinkedToExistingProject`;
  public static readonly emailedWhenReady = `${Id.prefix}emailedWhenReady`;
  public static readonly quoteDoesNotContainAnyLineItems = `${Id.prefix}quoteDoesNotContainAnyLineItems`;
  public static readonly cannotRejectOrCancelQuoteWithUnresolvedSupport = `${Id.prefix}cannotRejectOrCancelQuoteWithUnresolvedSupport`;
  public static readonly frameOutOfDateNeedsUpdate = `${Id.prefix}frameOutOfDateNeedsUpdate`;
  public static readonly frameOutOfDateCustomerVersion = `${Id.prefix}frameOutOfDateCustomerVersion`;
  public static readonly itemOutOfDateCustomerVersion = `${Id.prefix}itemOutOfDateCustomerVersion`;
  public static readonly frameOutOfDateNeedsUpdateBuyIn = `${Id.prefix}frameOutOfDateNeedsUpdateBuyIn`;
  public static readonly frameOutOfDateNeedsUpdateQuoteAttributes = `${Id.prefix}frameOutOfDateNeedsUpdateQuoteAttributes`;
  public static readonly frameOutOfDateNeedsUpdateIGU = `${Id.prefix}frameOutOfDateNeedsUpdateIGU`;
  public static readonly frameHasWarningsOrErrors = `${Id.prefix}frameHasWarningsOrErrors`;
  public static readonly unableToIssueQuoteValidForDays = `${Id.prefix}unableToIssueQuoteValidForDays`;
  public static readonly cannotIssueQuoteWithoutProject = `${Id.prefix}cannotIssueQuoteWithoutProject`;
  public static readonly projectDoesNotHaveStreetAddress = `${Id.prefix}projectDoesNotHaveStreetAddress`;
  public static readonly projectDoesNotHaveZipCode = `${Id.prefix}projectDoesNotHaveZipCode`;
  public static readonly quoteDoesNotHaveTitle = `${Id.prefix}quoteDoesNotHaveTitle`;
  public static readonly quotePricingMustBeUpdatedBeforeIssue = `${Id.prefix}quotePricingMustBeUpdatedBeforeIssue`;
  public static readonly validToDateMustBeInFuture = `${Id.prefix}validToDateMustBeInFuture`;
  public static readonly quoteShippingAddressDoesNotHaveStreetAddress = `${Id.prefix}quoteShippingAddressDoesNotHaveStreetAddress`;
  public static readonly quoteShippingAddressDoesNotHaveZipCode = `${Id.prefix}quoteShippingAddressDoesNotHaveZipCode`;
  public static readonly supplierReference = `${Id.prefix}supplierReference`;
  public static readonly validPrice = `${Id.prefix}validPrice`;
  public static readonly specialItemMustHaveBeforeQuoteCanBeIssued = `${Id.prefix}specialItemMustHaveBeforeQuoteCanBeIssued`;
  public static readonly specialItem = `${Id.prefix}specialItem`;
  public static readonly supportRequest = `${Id.prefix}supportRequest`;
  public static readonly supplierItemMustBeResolvedOrDeleted = `${Id.prefix}supplierItemMustBeResolvedOrDeleted`;
  public static readonly unableToIssueQuoteCorrectAndTryAgain = `${Id.prefix}unableToIssueQuoteCorrectAndTryAgain`;
  public static readonly cancelOrRejectQuote = `${Id.prefix}cancelOrRejectQuote`;
  public static readonly pleaseSelectReasonForStatusAction = `${Id.prefix}pleaseSelectReasonForStatusAction`;
  public static readonly statusReason = `${Id.prefix}statusReason`;
  public static readonly cancelledDueToSpecialItemDeletion = `${Id.prefix}cancelledDueToSpecialItemDeletion`;
  public static readonly reactivatedDueToSpecialItemUndeletion = `${Id.prefix}reactivatedDueToSpecialItemUndeletion`;
  public static readonly supportRequestResolvedBecauseQuoteAccepted = `${Id.prefix}supportRequestResolvedBecauseQuoteAccepted`;
  public static readonly supplierReview = `${Id.prefix}supplierReview`;
  public static readonly defaultQuoteCalculationLabel = `${Id.prefix}defaultQuoteCalculationLabel`;
  public static readonly salesCommissionCalculationLabel = `${Id.prefix}salesCommissionCalculationLabel`;
  public static readonly pricingModelTooltipDefault = `${Id.prefix}pricingModelTooltipDefault`;
  public static readonly pricingModelTooltipOverride = `${Id.prefix}pricingModelTooltipOverride`;
  public static readonly pricingModelTooltipSupplierConstrained = `${Id.prefix}pricingModelTooltipSupplierConstrained`;
  public static readonly copyingItemTitle = `${Id.prefix}copyingItemTitle`;
  public static readonly quoteConversationCopied = `${Id.prefix}quoteConversationCopied`;
  public static readonly pricingIsSetByTheSupplier = `${Id.prefix}pricingIsSetByTheSupplier`;
  public static readonly quoteHasCriticalAnnotation = `${Id.prefix}quoteHasCriticalAnnotations`;
  public static readonly quoteItemAttachToSupportRequestModifed = `${Id.prefix}quoteItemAttachToSupportRequestModifed`;
  public static readonly quoteItemAttachToSupportRequestDeleted = `${Id.prefix}quoteItemAttachToSupportRequestDeleted`;
  public static readonly supportRequestsUpdatedDueToItemChange = `${Id.prefix}supportRequestsUpdatedDueToItemChange`;
  public static readonly enterNewQuoteTitle = `${Id.prefix}enterNewQuoteTitle`;
  public static readonly cannotDeleteItemsAssignedToFabricationJobs = `${Id.prefix}cannotDeleteItemsAssignedToFabricationJobs`;
  public static readonly cannotCancelItemsAssignedToFabricationJobs = `${Id.prefix}cannotCancelItemsAssignedToFabricationJobs`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangFranchiseeQuoteManager {
  private constructor() {}

  public static currentUserDoesNotHaveBranch(): string {
    return interpolate(Id.currentUserDoesNotHaveBranch);
  }

  public static unableToCreatePurchaseOrder(): string {
    return interpolate(Id.unableToCreatePurchaseOrder);
  }

  public static issueOrderBySupplierFailed(params: { poId: string; tenantId: string }): string {
    return interpolate(Id.issueOrderBySupplierFailed, params);
  }

  public static issueOrderBySupplierFailedRecovered(): string {
    return interpolate(Id.issueOrderBySupplierFailedRecovered);
  }

  public static errorProcessingPurchaseOrder(): string {
    return interpolate(Id.errorProcessingPurchaseOrder);
  }

  public static purchaseOrderCreated(params: { poNumber: string }): string {
    return interpolate(Id.purchaseOrderCreated, params);
  }

  public static projectCreated(params: { projectNumber: string }): string {
    return interpolate(Id.projectCreated, params);
  }

  public static quoteLinkedToExistingProject(params: { projectNumber: string }): string {
    return interpolate(Id.quoteLinkedToExistingProject, params);
  }

  public static emailedWhenReady(): string {
    return interpolate(Id.emailedWhenReady);
  }

  public static quoteDoesNotContainAnyLineItems(): string {
    return interpolate(Id.quoteDoesNotContainAnyLineItems);
  }

  public static frameOutOfDateNeedsUpdate(params: { position: number }): string {
    return interpolate(Id.frameOutOfDateNeedsUpdate, params);
  }

  public static frameOutOfDateCustomerVersion(params: {
    position: number;
    itemVersion: number;
    currentVersion: number;
  }): string {
    return interpolate(Id.frameOutOfDateCustomerVersion, params);
  }

  public static itemOutOfDateCustomerVersion(params: { itemVersion: number; currentVersion: number }): string {
    return interpolate(Id.itemOutOfDateCustomerVersion, params);
  }

  public static frameOutOfDateNeedsUpdateBuyIn(params: { position: number }): string {
    return interpolate(Id.frameOutOfDateNeedsUpdateBuyIn, params);
  }

  public static frameOutOfDateNeedsUpdateQuoteAttributes(params: { position: number }): string {
    return interpolate(Id.frameOutOfDateNeedsUpdateQuoteAttributes, params);
  }

  public static frameOutOfDateNeedsUpdateIGU(params: { position: number }): string {
    return interpolate(Id.frameOutOfDateNeedsUpdateIGU, params);
  }

  public static frameHasWarningsOrErrors(params: { position: number }): string {
    return interpolate(Id.frameHasWarningsOrErrors, params);
  }

  public static unableToIssueQuoteValidForDays(): string {
    return interpolate(Id.unableToIssueQuoteValidForDays);
  }

  public static cannotIssueQuoteWithoutProject(): string {
    return interpolate(Id.cannotIssueQuoteWithoutProject);
  }

  public static projectDoesNotHaveStreetAddress(): string {
    return interpolate(Id.projectDoesNotHaveStreetAddress);
  }

  public static projectDoesNotHaveZipCode(): string {
    return interpolate(Id.projectDoesNotHaveZipCode);
  }

  public static quoteDoesNotHaveTitle(): string {
    return interpolate(Id.quoteDoesNotHaveTitle);
  }

  public static quotePricingMustBeUpdatedBeforeIssue(): string {
    return interpolate(Id.quotePricingMustBeUpdatedBeforeIssue);
  }

  public static validToDateMustBeInFuture(params: { validTo: string }): string {
    return interpolate(Id.validToDateMustBeInFuture, params);
  }

  public static quoteShippingAddressDoesNotHaveStreetAddress(): string {
    return interpolate(Id.quoteShippingAddressDoesNotHaveStreetAddress);
  }

  public static quoteShippingAddressDoesNotHaveZipCode(): string {
    return interpolate(Id.quoteShippingAddressDoesNotHaveZipCode);
  }

  public static supplierReference(): string {
    return interpolate(Id.supplierReference);
  }

  public static validPrice(): string {
    return interpolate(Id.validPrice);
  }

  public static specialItemMustHaveBeforeQuoteCanBeIssued(params: { issues: string }): string {
    return interpolate(Id.specialItemMustHaveBeforeQuoteCanBeIssued, params);
  }

  public static specialItem(): string {
    return interpolate(Id.specialItem);
  }

  public static supportRequest(): string {
    return interpolate(Id.supportRequest);
  }

  public static supplierItemMustBeResolvedOrDeleted(params: { itemType: string; subject: string }): string {
    return interpolate(Id.supplierItemMustBeResolvedOrDeleted, params);
  }

  public static unableToIssueQuoteCorrectAndTryAgain(): string {
    return interpolate(Id.unableToIssueQuoteCorrectAndTryAgain);
  }

  public static cancelOrRejectQuote(isCancel: boolean): string {
    return interpolate(Id.cancelOrRejectQuote, undefined, isCancel ? undefined : 'reject');
  }

  public static pleaseSelectReasonForStatusAction(isCancel: boolean): string {
    return interpolate(Id.pleaseSelectReasonForStatusAction, undefined, isCancel ? undefined : 'reject');
  }

  public static statusReason(isCancel: boolean): string {
    return interpolate(Id.statusReason, undefined, isCancel ? undefined : 'reject');
  }

  public static cancelledDueToSpecialItemDeletion(): string {
    return interpolate(Id.cancelledDueToSpecialItemDeletion);
  }

  public static reactivatedDueToSpecialItemUndeletion(): string {
    return interpolate(Id.reactivatedDueToSpecialItemUndeletion);
  }

  public static supportRequestResolvedBecauseQuoteAccepted(params: { quoteNumber: string }): string {
    return interpolate(Id.supportRequestResolvedBecauseQuoteAccepted, params);
  }

  public static supplierReview(): string {
    return interpolate(Id.supplierReview);
  }

  public static salesCommissionCalculationLabel(params: { calculationLabel: string }): string {
    return interpolate(Id.salesCommissionCalculationLabel, params);
  }

  public static defaultQuoteCalculationLabel(params: { calculationLabel: string }): string {
    return interpolate(Id.defaultQuoteCalculationLabel, params);
  }

  public static pricingModelTooltipDefault(params: { calculationLabel: string; value: number }): string {
    return interpolate(Id.pricingModelTooltipDefault, params);
  }

  public static pricingModelTooltipOverride(params: { value: number }): string {
    return interpolate(Id.pricingModelTooltipOverride, params);
  }

  public static pricingModelTooltipSupplierConstrained(params: { supplierName: string; constraint: string }): string {
    return interpolate(Id.pricingModelTooltipSupplierConstrained, params);
  }

  public static copyingItemTitle(params: { title: string }): string {
    return interpolate(Id.copyingItemTitle, params);
  }
  public static supportRequestsUpdatedDueToItemChange(count: number, segmentName?: string): string {
    return interpolate(Id.supportRequestsUpdatedDueToItemChange, { count }, segmentName);
  }
  public static quoteConversationCopied(params: { quoteNumber: string; position: number; itemTitle: string }): string {
    return interpolate(Id.quoteConversationCopied, params);
  }

  public static quoteItemAttachToSupportRequestModifed(report: string, segmentName?: string): string {
    return interpolate(Id.quoteItemAttachToSupportRequestModifed, { report }, segmentName);
  }
  public static quoteItemAttachToSupportRequestDeleted(report: string, segmentName?: string): string {
    return interpolate(Id.quoteItemAttachToSupportRequestDeleted, { report }, segmentName);
  }
  public static pricingIsSetByTheSupplier(): string {
    return interpolate(Id.pricingIsSetByTheSupplier);
  }

  public static quoteHasCriticalAnnotation(params: { annotation: string }): string {
    return interpolate(Id.quoteHasCriticalAnnotation, params);
  }

  public static cannotRejectOrCancelQuoteWithUnresolvedSupport(params: { state: string }): string {
    return interpolate(Id.cannotRejectOrCancelQuoteWithUnresolvedSupport, params);
  }

  public static enterNewQuoteTitle(): string {
    return interpolate(Id.enterNewQuoteTitle);
  }

  public static cannotDeleteItemsAssignedToFabricationJobs(params: { count: number }): string {
    return interpolate(Id.cannotDeleteItemsAssignedToFabricationJobs, params);
  }

  public static cannotCancelItemsAssignedToFabricationJobs(params: { count: number }): string {
    return interpolate(Id.cannotCancelItemsAssignedToFabricationJobs, params);
  }
}

export class FranchiseeQuoteManagerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.quoteConversationCopied,
      `This {{glossary 'special-item'}} has been duplicated from its original {{glossary 'quote'}} as an alternative:
{{quoteNumber}}                
#{{position}} {{itemTitle}}`,
      'Text added to conversation when a quote item is copied (duplicated) to a new quote'
    );

    register.add(
      Id.currentUserDoesNotHaveBranch,
      "Current User does not have a {{glossary 'branch'}}.",
      'Error when user has no branch'
    );
    register.add(
      Id.unableToCreatePurchaseOrder,
      "Unable to create {{glossary 'purchase-order'}}.",
      'Error when unable to create purchase order'
    );
    register.add(
      Id.issueOrderBySupplierFailed,
      `An error occurred while attempting to {{glossary 'purchase-order-state-issued'}} the {{glossary 'purchase-order'}}\n\nReverting to {{glossary 'purchase-order-state-draft'}} failed, please contact support to help rectify this.\n\nSupport will manually need to fix the state on this order to {{glossary 'purchase-order-state-draft'}}\n\nplease note the number "Tenant-{{tenantId}}:PO-{{poId}}"`,
      'Error message for failed supplier-issued order, unrecoverable'
    );
    register.add(
      Id.issueOrderBySupplierFailedRecovered,
      `An error occurred while attempting to {{glossary 'purchase-order-state-issued'}} the {{glossary 'purchase-order'}}\n\n{{glossary 'purchaseorder'}} has been set to {{glossary 'purchaseorder-state-draft'}} and will need to be processed later.`,
      'Error message for failed supplier-issued order, recovered'
    );
    register.add(
      Id.errorProcessingPurchaseOrder,
      "Error processing {{glossary 'purchase-order'}}",
      'Title for error processing purchase order'
    );
    register.add(
      Id.purchaseOrderCreated,
      "{{glossary 'purchase-order'}} {{poNumber}} created!",
      'Toast for created purchase order'
    );
    register.add(Id.projectCreated, "{{glossary 'project'}} {{projectNumber}} created!", 'Toast for created project');
    register.add(
      Id.quoteLinkedToExistingProject,
      "{{glossary 'quote'}} linked to existing {{glossary 'project'}}! {{projectNumber}}",
      'Toast for linking quote to existing project'
    );
    register.add(
      Id.emailedWhenReady,
      'You will be emailed a link to the document when it is ready',
      'Info for emailed document'
    );
    register.add(
      Id.quoteDoesNotContainAnyLineItems,
      "{{glossary 'quote'}} doesn't contain any line items.",
      'Error for quote with no line items'
    );
    register.add(
      Id.frameOutOfDateNeedsUpdate,
      "{{glossary 'frame'}} Position {{position}} needs to be updated because of {{glossary 'supplier'}} changes",
      'Frame out of date due to supplier changes'
    );
    register.add(
      Id.frameOutOfDateCustomerVersion,
      "{{glossary 'frame'}} Position {{position}} needs to be updated because the {{glossary 'supplier'}} has updated its settings for this {{glossary 'franchisee'}} {{glossary 'branch'}} ({{glossary 'franchisee'}} {{glossary 'branch'}} version {{itemVersion}}, now {{currentVersion}})",
      'Frame out of date because the supplier raised the version of the dealership branch customer code (SUPVER-008)'
    );
    register.add(
      Id.itemOutOfDateCustomerVersion,
      "The {{glossary 'supplier'}} has updated its settings for this {{glossary 'franchisee'}} {{glossary 'branch'}}. This {{glossary 'frame'}} must be revalidated. {{glossary 'franchisee'}} {{glossary 'branch'}} version: {{itemVersion}}, now {{currentVersion}}",
      'Item validation explanation when the supplier raised the version of the dealership branch customer code (SUPVER-008)'
    );
    register.add(
      Id.frameOutOfDateNeedsUpdateBuyIn,
      "{{glossary 'frame'}} Position {{position}} needs to be updated because of {{glossary 'stock'}} changes",
      'Frame out of date due to stock changes'
    );
    register.add(
      Id.frameOutOfDateNeedsUpdateQuoteAttributes,
      "{{glossary 'frame'}} Position {{position}} needs to be updated because of {{glossary 'quote'}} attribute changes",
      'Frame out of date due to quote attribute changes'
    );
    register.add(
      Id.frameOutOfDateNeedsUpdateIGU,
      "{{glossary 'frame'}} Position {{position}} needs to be updated because of {{glossary 'quote'}} IGU changes",
      'Frame out of date due to quote IGU changes'
    );
    register.add(
      Id.frameHasWarningsOrErrors,
      "{{glossary 'frame'}} Position {{position}} has Warnings/Errors that must be addressed",
      'Frame has warnings/errors'
    );
    register.add(
      Id.unableToIssueQuoteValidForDays,
      'Unable to issue {{glossary \'quote\'}} because the setting for "Valid for (Days):" cannot be resolved.',
      'Error for missing valid for days'
    );
    register.add(
      Id.cannotIssueQuoteWithoutProject,
      "Cannot issue a {{glossary 'quote'}} without being part of a valid {{glossary 'project'}}. Please contact your support if this seems incorrect",
      'Error for missing project'
    );
    register.add(
      Id.projectDoesNotHaveStreetAddress,
      "{{glossary 'project'}} does not have a Street Address",
      'Project missing street address'
    );
    register.add(
      Id.projectDoesNotHaveZipCode,
      "{{glossary 'project'}} does not have a Zip Code",
      'Project missing zip code'
    );
    register.add(Id.quoteDoesNotHaveTitle, "{{glossary 'quote'}} does not have a title", 'Quote missing title');
    register.add(
      Id.quotePricingMustBeUpdatedBeforeIssue,
      "{{glossary 'quote'}} pricing is out of date after a batch change — click Update Price before issuing.",
      'Issue blocked because SSI/pricing was deferred by a batch change'
    );
    register.add(
      Id.validToDateMustBeInFuture,
      '\'Valid to\' Date "{{validTo}}" must be a date in the future not in the past.',
      'Valid to date must be in future'
    );
    register.add(
      Id.quoteShippingAddressDoesNotHaveStreetAddress,
      "{{glossary 'quote'}} shipping address does not have a Street Address",
      'Quote shipping address missing street'
    );
    register.add(
      Id.quoteShippingAddressDoesNotHaveZipCode,
      "{{glossary 'quote'}} shipping address does not have a Zip Code",
      'Quote shipping address missing zip'
    );
    register.add(Id.supplierReference, 'Supplier Reference', 'Supplier reference label');
    register.add(Id.validPrice, 'valid Price', 'Valid price label');
    register.add(
      Id.specialItemMustHaveBeforeQuoteCanBeIssued,
      "{{glossary 'special-item'}} must have a {{issues}} before a Quote can be Issued",
      'Special item must have issues resolved'
    );
    register.add(Id.specialItem, "{{glossary 'special-item'}}", 'Special item glossary');
    register.add(Id.supportRequest, "{{glossary 'support-request'}}", 'Support request glossary');
    register.add(
      Id.supplierItemMustBeResolvedOrDeleted,
      '{{glossary \'supplier\'}} {{itemType}} "{{subject}}" must be resolved or deleted.',
      'Supplier item must be resolved or deleted'
    );
    register.add(
      Id.unableToIssueQuoteCorrectAndTryAgain,
      "Unable to issue {{glossary 'quote'}}, correct the following and try again.",
      'Unable to issue quote, correct and try again'
    );
    register
      .add(Id.cancelOrRejectQuote, "Cancel {{glossary 'quote'}}", 'Cancel or reject quote')
      .addSegment('reject', "Reject {{glossary 'quote'}}");
    register
      .add(
        Id.pleaseSelectReasonForStatusAction,
        "Please select the reason for cancelling the {{glossary 'quote'}}",
        'Please select reason for status action'
      )
      .addSegment('reject', "Please select the reason for rejecting the {{glossary 'quote'}}");
    register
      .add(Id.statusReason, 'Cancellation Reason', 'Status reason label')
      .addSegment('reject', 'Rejection Reason');
    register.add(
      Id.cancelledDueToSpecialItemDeletion,
      "Cancelled due to {{glossary 'special-item'}} deletion",
      'Cancelled due to special item deletion'
    );
    register.add(
      Id.reactivatedDueToSpecialItemUndeletion,
      "Reactivated due to {{glossary 'special-item'}} undeletion",
      'Reactivated due to special item undeletion'
    );
    register.add(
      Id.supportRequestResolvedBecauseQuoteAccepted,
      "{{glossary 'support-request-resolved'}} because {{glossary 'quote'}} {{quoteNumber}} has been {{glossary 'quote-state-accepted'}}",
      'Support request resolved because quote accepted'
    );
    register.add(Id.supplierReview, "{{glossary 'supplier'}} Review", 'Supplier review');
    register.add(
      Id.defaultQuoteCalculationLabel,
      "Default {{glossary 'quote'}} {{calculationLabel}}",
      'Default quote calculation label'
    );

    register.add(
      Id.salesCommissionCalculationLabel,
      'Sales Commission ({{calculationLabel}})',
      'Sales commission label'
    );
    register.add(
      Id.pricingModelTooltipDefault,
      "The default {{glossary 'quote'}} {{glossary 'payment-profile'}} {{calculationLabel}} is **{{value}}%**",
      'Tooltip for default quote pricing model'
    );
    register.add(
      Id.pricingModelTooltipOverride,
      "the current {{glossary 'quote'}} default is {{value}}%",
      'Tooltip for quote pricing model override'
    );
    register.add(
      Id.pricingModelTooltipSupplierConstrained,
      '**{{supplierName}}** has enforced a constraint of **{{constraint}}**',
      'Tooltip for supplier-constrained pricing model'
    );
    register.add(Id.copyingItemTitle, 'Copying {{title}}', 'Dialog title for copying a quote item');
    register.add(
      Id.pricingIsSetByTheSupplier,
      "Pricing is set by the {{glossary 'supplier'}}. Contact your {{glossary 'supplier'}} for more information.",
      'Message indicating that pricing is set by the supplier and not editable by the user'
    );
    register.add(
      Id.quoteHasCriticalAnnotation,
      "{{glossary 'quote'}} has a critical issue: {{annotation}}",
      'Error for quote with a critical annotation returned from supplier'
    );

    register.add(
      Id.cannotRejectOrCancelQuoteWithUnresolvedSupport,
      "Cannot {{state}} {{glossary 'quote'}} because there are unresolved {{glossary 'support-request:plural'}}",
      'Error message when a quote cannot be rejected or cancelled due to unresolved support items'
    );

    register.add(
      Id.enterNewQuoteTitle,
      "Enter new {{glossary 'quote'}} Title",
      'Prompt to enter a new title when copying a quote'
    );

    register
      .add(
        Id.quoteItemAttachToSupportRequestModifed,
        `The following {{glossary 'quote-item'}} has been updated. Please review the item to ensure it meets the required specifications.
      and check if the {{glossary 'support-request'}} needs to be updated.

    {{report}}
`,
        'Message added to support request when quote item details are attached'
      )
      .addSegment(
        'eto',
        `An update was made to the {{glossary 'special-item'}}. Please review to ensure it meets the required specifications.
      
      {{report}}`
      );
    register
      .add(
        Id.quoteItemAttachToSupportRequestDeleted,
        `The following {{glossary 'quote-item'}} has been deleted. Please review the item to ensure it meets the required specifications.
      and check if the {{glossary 'support-request'}} needs to be updated or cancelled.

    {{report}}
`,
        'Message added to support request when quote item details are deleted'
      )
      .addSegment(
        'eto',
        `An update was made to the {{glossary 'special-item'}}. Please review to ensure it meets the required specifications.
      
      {{report}}`
      );

    register
      .add(
        Id.supportRequestsUpdatedDueToItemChange,
        "{{count}} {{glossary 'support-request:plural'}} updated due to changes in {{glossary 'quote-item'}}",
        'Toast message indicating the number of support requests updated due to changes in a quote item'
      )
      .addSegment('eto', "an update was made to the {{glossary 'special-item'}}");

    register.add(
      Id.cannotDeleteItemsAssignedToFabricationJobs,
      'Cannot delete: {{count}} item(s) are assigned to fabrication jobs. Remove them from their jobs first.',
      'Validation message when trying to delete quote items assigned to fabrication jobs'
    );
    register.add(
      Id.cannotCancelItemsAssignedToFabricationJobs,
      'Cannot cancel: {{count}} item(s) are assigned to fabrication jobs. Remove them from their jobs first.',
      'Validation message when trying to cancel quote with items assigned to fabrication jobs'
    );
  }
}
